import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Roadmap() {
    return (
        <>
            <Header />
            <div class="roadmap-div">

                <div class="roadmap-div-sub">
                    <iframe src="https://airtable.com/embed/app0AuSGMM8W3vrBW/shrJiaN73UwLRsURw/tblr7pXiElTxjOigx" title="roadmap" height="1000" class="relative w-full overflow-hidden" allow="fullscreen; clipboard-write; autoplay" ></iframe>
                </div>
            </div>

            <Footer />
        </>
    )
}